__turbopack_context__.v({
  "overlay": "EmbeddedVideo-module__Aofwpq__overlay",
  "video": "EmbeddedVideo-module__Aofwpq__video",
});
